/**
 * Centraliza o tratamento de erros de API
 */

export function handleApiError(error, context = "") {
  console.error(`[${context}] Erro:`, error);

  if (error instanceof TypeError) {
    if (error.message.includes("Failed to fetch")) {
      console.error(`[${context}] Erro de conexão - verifique o URL da API`);
      return new Error("Erro de conexão com o servidor");
    }
  }

  if (error instanceof DOMException && error.name === "AbortError") {
    console.warn(`[${context}] Requisição cancelada`);
    return error;
  }

  return error;
}

export function isAuthError(response) {
  return response.status === 401 || response.status === 403;
}

export function getErrorMessage(response) {
  const status = response.status;
  
  if (status === 401) return "Sessão expirada. Faça login novamente.";
  if (status === 403) return "Acesso negado.";
  if (status === 404) return "Recurso não encontrado.";
  if (status === 429) return "Muitas requisições. Tente novamente em breve.";
  if (status >= 500) return "Erro no servidor. Tente novamente mais tarde.";
  
  return `Erro ${status}`;
}
